import { getProductScenario } from "@/features/sub-families/utils/power-supply-dimming-type.ts";
import { getEmptyConfigCode } from "@/features/sub-families/utils/smart-number.ts";
import { getSupplies } from "@/lib/product.ts";
import { useAppSelector } from "@/redux/store.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { SmartNumberDescriptor } from "@/types";

export default function useCurrentPowerSupply() {
    const currentProduct = useCurrentProduct();
    const smartNumberMapping = useAppSelector((state) => state.smartNumber.mapping);
    const smartNumberDescription = useAppSelector((state) => state.smartNumber.description);

    if (!currentProduct || !smartNumberMapping || !smartNumberDescription) return null;

    const productScenario = getProductScenario(currentProduct);
    if (productScenario !== 2 && productScenario !== 3) return null;

    const configCode = smartNumberMapping[SmartNumberDescriptor.PowerSupply];
    const emptyConfigCode = getEmptyConfigCode(SmartNumberDescriptor.PowerSupply, smartNumberDescription);
    if (configCode === emptyConfigCode) return null;

    return getSupplies(currentProduct).find((supply) => supply.code === configCode) ?? null;
}
